export enum StornoStepEnum {
    Preferences = 1,
    Reason = 2,
    Discount = 3,
    AlreadyHaveDiscount = 4,
    InformationAboutDeletion = 5,
}
